import { Theme } from "@mui/material";

export function scheduleSelectionDialogStyle({
  isMobileTablet,
  isMobile,
  theme
}: {
  isMobileTablet: boolean;
  isMobile: boolean;
  theme: Theme;
}) {
  const tableSxStyle = {
    fontSize: isMobileTablet ? 12 : 17,
    fontWeight: theme.typography.fontWeightRegular,
    pl: isMobileTablet ? 0 : 5,
    pr: isMobileTablet ? 0 : 5,
    "&.Mui-selected": {
      color:
        theme.palette.mode === "dark"
          ? theme.palette.getContrastText(theme.palette.primary.main)
          : theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightBold
    }
  };

  const dialogStyleTop = isMobile ? "60px" : "64px";
  const dialogStyleWidth = isMobileTablet ? "none" : "35vw";

  return { tableSxStyle, dialogStyleTop, dialogStyleWidth };
}
